var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outline Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.279,7.847A1.159,1.159,0,1,0,9.438,9.006,1.159,1.159,0,0,0,8.279,7.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.887,7.847a1.159,1.159,0,1,0,1.159,1.159A1.159,1.159,0,0,0,12.887,7.847Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.279,
    cy: 13.625,
    r: 1.159
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.887,
    cy: 13.625,
    r: 1.159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.541,13.128l-1.833,1.408V4.715A2.632,2.632,0,0,0,16,2.006H5.166A2.632,2.632,0,0,0,2.458,4.715V29.994H29.542V20.089Zm-9.055,15.06H4.263V4.715a.826.826,0,0,1,.9-.9H16a.826.826,0,0,1,.9.9V15.924l-5.417,4.164Zm10.608,0h-3.16v-3.8h3.16Zm5.643,0H23.448V24.076A1.047,1.047,0,0,0,22.4,23.03H18.626a1.048,1.048,0,0,0-1.046,1.046v4.112H13.292V20.977l5.416-4.163h0l1.83-1.406,7.2,5.568Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0eec1b3fed3a21eaeb1dcd66f000c19f.svg";
export { ForwardRef as ReactComponent };